export enum BackgroundJobType {
  COMPLETE_ORDER,
  REMOVE_FILES,
  PROCESS_SINGLE_BMP,
  GENERATE_SCHEDULE_ZIP,
  ERP_CREATE_SCHEDULE
}
